import React from "react";
import { Compare } from "./Compare";

const PlainResume = () => {
  return (
    <div className="w-full h-full bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <div className="space-y-3 text-xs">
        <div>
          <h3 className="text-base font-bold text-gray-900">Aravind Srinivas</h3>
          <p className="text-xs text-gray-600">Gen-AI Engineer</p>
          <p className="text-[10px] text-gray-500">aravind.srini@msn.com</p>
        </div>
        
        <div>
          <h4 className="text-xs font-semibold text-gray-800 mb-1">Experience</h4>
          <div>
            <div>
              <p className="text-xs font-medium text-gray-900">Fullstack Developer</p>
              <p className="text-[10px] text-gray-600">Zomato | July 2023 - Jan 2024</p>
              <p className="text-[10px] text-gray-500 mt-0.5">Built new AI features for 30M consumers</p>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold text-gray-800 mb-1">Education</h4>
          <p className="text-xs text-gray-900">B.E. IT</p>
          <p className="text-[10px] text-gray-600">NIT Suratkal</p>
        </div>

        <div>
          <h4 className="text-xs font-semibold text-gray-800 mb-1">Skills</h4>
          <p className="text-[10px] text-gray-600">Gen-AI, Node.Js, Python, RAG</p>
        </div>
      </div>
    </div>
  );
};

const AnnotatedResume = () => {
  return (
    <div className="w-full h-full bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <div className="space-y-3 text-xs">
        <div>
          <div className="flex items-start justify-between mb-1">
            <div>
              <h3 className="text-base font-bold text-gray-900">Aravind Srinivas</h3>
              <p className="text-xs text-gray-600">Gen-AI Engineer</p>
              <p className="text-[10px] text-gray-500">aravind.srini@msn.com</p>
            </div>
            <div className="flex flex-wrap gap-0.5">
              <span className="px-1.5 py-0.5 text-[10px] font-medium bg-green-100 text-green-800 rounded-full">Fast Career Growth</span>
              <span className="px-1.5 py-0.5 text-[10px] font-medium bg-red-100 text-red-800 rounded-full">Job Hopper</span>
            </div>
          </div>
        </div>
        
        <div>
          <h4 className="text-xs font-semibold text-gray-800 mb-1">Experience</h4>
          <div>
            <div className="border-l-2 border-blue-500 pl-2">
              <div className="flex items-center gap-1 mb-0.5 flex-wrap">
                <p className="text-xs font-medium text-gray-900">Fullstack Developer</p>
                <span className="px-1.5 py-0.5 text-[10px] font-medium bg-purple-100 text-purple-800 rounded-full">Product Company</span>
              </div>
              <p className="text-[10px] text-gray-600">Zomato | 2022 - present</p>
              <p className="text-[10px] text-gray-500 mt-0.5">Built new AI features for 30M consumers</p>
              <div className="flex flex-wrap gap-0.5 mt-1">
                <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">Gen-AI</span>
                <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">Node.Js</span>
                <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">Python</span>
                <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">RAG</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold text-gray-800 mb-1">Education</h4>
          <div className="border-l-2 border-blue-500 pl-2">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs text-gray-900">B.E. IT</p>
                <p className="text-[10px] text-gray-600">NIT Suratkal</p>
              </div>
              <span className="px-1.5 py-0.5 text-[10px] font-medium bg-blue-100 text-blue-800 rounded-full">Tier 1 School</span>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold text-gray-800 mb-1">Skills</h4>
          <div className="flex flex-wrap gap-0.5">
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">Gen-AI</span>
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">Node.Js</span>
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">Python</span>
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-orange-100 text-orange-800 rounded-full">RAG</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ResumeComparison = () => {
  return (
    <div className="w-full h-[280px]">
      <Compare
        firstContent={<PlainResume />}
        secondContent={<AnnotatedResume />}
        slideMode="hover"
        autoplay={true}
        autoplayDuration={4000}
        initialSliderPercentage={50}
        className="h-full"
      />
    </div>
  );
};

